module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7vXcf"))).then(() => module.bundle.root('hEqeo'));